import * as Types from '../../../graphql/types';

import { CalendarMonthString, CalendarDateTimeString, CalendarDateString } from "scalars";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMetricCardPreferencesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['CompanyID']['input'];
}>;


export type GetMetricCardPreferencesQuery = { __typename?: 'Query', getMetricCardPreferences: { __typename?: 'MetricCardPreferences', companyId: any, userId: any, metricCardPreferences: Array<{ __typename?: 'MetricCardPreference', metricCard: Types.MetricCard, enabled: boolean }> } };

export type UpdateMetricCardPreferencesMutationVariables = Types.Exact<{
  input: Types.UpdateMetricCardPreferencesInput;
}>;


export type UpdateMetricCardPreferencesMutation = { __typename?: 'Mutation', updateMetricCardPreferences: { __typename?: 'UpdateMetricCardPreferencesResult', companyId: any, userId: any, metricCardPreferences: Array<{ __typename?: 'MetricCardPreference', metricCard: Types.MetricCard, enabled: boolean }> } };


export const GetMetricCardPreferencesDocument = gql`
    query getMetricCardPreferences($companyId: CompanyID!) {
  getMetricCardPreferences(companyId: $companyId) {
    companyId
    userId
    metricCardPreferences {
      metricCard
      enabled
    }
  }
}
    `;

/**
 * __useGetMetricCardPreferencesQuery__
 *
 * To run a query within a React component, call `useGetMetricCardPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricCardPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricCardPreferencesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetMetricCardPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetMetricCardPreferencesQuery, GetMetricCardPreferencesQueryVariables> & ({ variables: GetMetricCardPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricCardPreferencesQuery, GetMetricCardPreferencesQueryVariables>(GetMetricCardPreferencesDocument, options);
      }
export function useGetMetricCardPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricCardPreferencesQuery, GetMetricCardPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricCardPreferencesQuery, GetMetricCardPreferencesQueryVariables>(GetMetricCardPreferencesDocument, options);
        }
export function useGetMetricCardPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricCardPreferencesQuery, GetMetricCardPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricCardPreferencesQuery, GetMetricCardPreferencesQueryVariables>(GetMetricCardPreferencesDocument, options);
        }
export type GetMetricCardPreferencesQueryHookResult = ReturnType<typeof useGetMetricCardPreferencesQuery>;
export type GetMetricCardPreferencesLazyQueryHookResult = ReturnType<typeof useGetMetricCardPreferencesLazyQuery>;
export type GetMetricCardPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetMetricCardPreferencesSuspenseQuery>;
export type GetMetricCardPreferencesQueryResult = Apollo.QueryResult<GetMetricCardPreferencesQuery, GetMetricCardPreferencesQueryVariables>;
export const UpdateMetricCardPreferencesDocument = gql`
    mutation updateMetricCardPreferences($input: UpdateMetricCardPreferencesInput!) {
  updateMetricCardPreferences(input: $input) {
    companyId
    userId
    metricCardPreferences {
      metricCard
      enabled
    }
  }
}
    `;
export type UpdateMetricCardPreferencesMutationFn = Apollo.MutationFunction<UpdateMetricCardPreferencesMutation, UpdateMetricCardPreferencesMutationVariables>;

/**
 * __useUpdateMetricCardPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateMetricCardPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricCardPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricCardPreferencesMutation, { data, loading, error }] = useUpdateMetricCardPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricCardPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetricCardPreferencesMutation, UpdateMetricCardPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetricCardPreferencesMutation, UpdateMetricCardPreferencesMutationVariables>(UpdateMetricCardPreferencesDocument, options);
      }
export type UpdateMetricCardPreferencesMutationHookResult = ReturnType<typeof useUpdateMetricCardPreferencesMutation>;
export type UpdateMetricCardPreferencesMutationResult = Apollo.MutationResult<UpdateMetricCardPreferencesMutation>;
export type UpdateMetricCardPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateMetricCardPreferencesMutation, UpdateMetricCardPreferencesMutationVariables>;